import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, enum_type, bool_type, option_type, class_type, union_type, string_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Banner_DesktopImageUploaded_$reflection, Banner_AdminBanner_$reflection, Banner_AdminBannerListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { State_$reflection } from "../../../fable_modules/Fulma.Elmish.1.0.0/DatePicker/Types.fs.js";
import { Remote$1, UserSession_$reflection, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { DateFormField__get_IsValid, FormField__get_IsValid, DateValidationRule, DateFormField_Init_Z492D238E, ValidationRule, FormField_Init_Z1F39563A, DateFormField_$reflection, FormField_$reflection } from "../../../../Bfs.Web.Portale/Validation.fs.js";

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BannerList", "BannerEdit", "BannerNew"];
    }
}

export function Page_$reflection() {
    return union_type("AdminBanner.Types.Page", [], Page, () => [[["page", int32_type]], [["id", string_type]], []]);
}

export class Filter extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Alle", "Pflege", "Therapie", "BfsPlus", "Jugendhilfe"];
    }
}

export function Filter_$reflection() {
    return union_type("AdminBanner.Types.Filter", [], Filter, () => [[], [], [], [], []]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadBannerPage", "BannerPageLoaded", "FilterChanged", "ActivateBanner", "DeactivateBanner", "ActiveChanged", "NewBanner", "LoadBanner", "BannerLoaded", "TagChanged", "TitelChanged", "TextChanged", "GueltigAbChanged", "GueltigBisChanged", "AktivChanged", "ImageOnlyChanged", "KundenTypChanged", "TextFarbeChanged", "DeleteImageDesktop", "UploadImageDesktop", "DesktopImageUploaded", "DeleteImageMobile", "UploadImageMobile", "MobileImageUploaded", "Save", "Saved", "SavedNew", "ValidateImageOnly", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("AdminBanner.Types.Msg", [], Msg, () => [[["page", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(Banner_AdminBannerListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(Banner_AdminBannerListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", Filter_$reflection()]], [["id", string_type]], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["id", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Banner_AdminBanner_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Banner_AdminBanner_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item1", State_$reflection()], ["Item2", option_type(class_type("System.DateTime"))]], [["Item1", State_$reflection()], ["Item2", option_type(class_type("System.DateTime"))]], [["Item", bool_type]], [["Item", bool_type]], [["Item", option_type(enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.KundenTyp", int32_type, [["Pflege", 1], ["Therapie", 2], ["BfsPlus", 4], ["Jugendhilfe", 5]]))]], [["Item", string_type]], [], [["Item", class_type("Browser.Types.Blob", undefined)]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Banner_DesktopImageUploaded_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Banner_DesktopImageUploaded_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", class_type("Browser.Types.Blob", undefined)]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("System.Guid"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("System.Guid")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ListModel", "ItemModel"];
    }
}

export function Model_$reflection() {
    return union_type("AdminBanner.Types.Model", [], Model, () => [[["Item", BannerListModel_$reflection()]], [["Item", BannerModel_$reflection()]]]);
}

export class BannerListModel extends Record {
    constructor(PageNumber, Filter, Banner) {
        super();
        this.PageNumber = (PageNumber | 0);
        this.Filter = Filter;
        this.Banner = Banner;
    }
}

export function BannerListModel_$reflection() {
    return record_type("AdminBanner.Types.BannerListModel", [], BannerListModel, () => [["PageNumber", int32_type], ["Filter", Filter_$reflection()], ["Banner", Remote$1_$reflection(Paginated$1_$reflection(Banner_AdminBannerListItem_$reflection()))]]);
}

export class BannerModel extends Record {
    constructor(Id, BackToPage, Tag, HintergrundFarbe, TextFarbe, Titel, Text$, GueltigAb, GueltigBis, Aktiv, KundenTyp, HasImageDesktop, HasImageMobile, ImageOnly, ImageOnlyEnabled, IsDirty, Sending, TextAsHtml, UserSession, UploadTrigger) {
        super();
        this.Id = Id;
        this.BackToPage = (BackToPage | 0);
        this.Tag = Tag;
        this.HintergrundFarbe = HintergrundFarbe;
        this.TextFarbe = TextFarbe;
        this.Titel = Titel;
        this.Text = Text$;
        this.GueltigAb = GueltigAb;
        this.GueltigBis = GueltigBis;
        this.Aktiv = Aktiv;
        this.KundenTyp = KundenTyp;
        this.HasImageDesktop = HasImageDesktop;
        this.HasImageMobile = HasImageMobile;
        this.ImageOnly = ImageOnly;
        this.ImageOnlyEnabled = ImageOnlyEnabled;
        this.IsDirty = IsDirty;
        this.Sending = Sending;
        this.TextAsHtml = TextAsHtml;
        this.UserSession = UserSession;
        this.UploadTrigger = (UploadTrigger | 0);
    }
}

export function BannerModel_$reflection() {
    return record_type("AdminBanner.Types.BannerModel", [], BannerModel, () => [["Id", option_type(string_type)], ["BackToPage", int32_type], ["Tag", FormField_$reflection()], ["HintergrundFarbe", string_type], ["TextFarbe", string_type], ["Titel", FormField_$reflection()], ["Text", FormField_$reflection()], ["GueltigAb", DateFormField_$reflection()], ["GueltigBis", DateFormField_$reflection()], ["Aktiv", bool_type], ["KundenTyp", option_type(enum_type("Bfs.Web.Data.Service.Contracts.Kundenportal.KundenTyp", int32_type, [["Pflege", 1], ["Therapie", 2], ["BfsPlus", 4], ["Jugendhilfe", 5]]))], ["HasImageDesktop", bool_type], ["HasImageMobile", bool_type], ["ImageOnly", bool_type], ["ImageOnlyEnabled", bool_type], ["IsDirty", bool_type], ["Sending", bool_type], ["TextAsHtml", string_type], ["UserSession", option_type(UserSession_$reflection())], ["UploadTrigger", int32_type]]);
}

export function BannerListModel_Init_Z524259A4(pagenumber) {
    return new BannerListModel(pagenumber, new Filter(0, []), new Remote$1(1, []));
}

export function BannerModel_Init(id, backToPage, session) {
    const Titel = FormField_Init_Z1F39563A(new ValidationRule(2, [200]));
    const Text$ = FormField_Init_Z1F39563A(new ValidationRule(0, []));
    const GueltigAb = DateFormField_Init_Z492D238E(new DateValidationRule(0, []));
    const GueltigBis = DateFormField_Init_Z492D238E(new DateValidationRule(0, []));
    return new BannerModel(id, backToPage, FormField_Init_Z1F39563A(undefined), "#FFFFFF", "", Titel, Text$, GueltigAb, GueltigBis, true, undefined, false, false, false, false, false, false, "", session, 0);
}

export function BannerModel__get_CanSubmit(x) {
    if ((((!x.Sending && FormField__get_IsValid(x.Titel)) && FormField__get_IsValid(x.Text)) && DateFormField__get_IsValid(x.GueltigAb)) && DateFormField__get_IsValid(x.GueltigBis)) {
        return FormField__get_IsValid(x.Tag);
    }
    else {
        return false;
    }
}

//# sourceMappingURL=Types.fs.js.map
